import _ from 'lodash';

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: ['value', 'html', 'checkedValue', 'uncheckedValue', 'disabled'],
  data: data,
  computed: {
    isChecked: isChecked,
    isMultiple: isMultiple
  },
  methods: {
    change: change
  }
}

function data(){
  return {
    checked: _.isUndefined(this.checkedValue) ? true : this.checkedValue,
    unchecked: _.isUndefined(this.uncheckedValue) ? false : this.uncheckedValue
  };
}

function change(event){
  if(this.disabled) return;
  let value = null;

  if(this.isMultiple){
    value = _.xor(this.value, [this.checked]);
  }else{
    value = event.target.checked ? this.checked : this.unchecked;
  }

  this.$emit('change', value);
}

function isChecked(){
  return this.isMultiple ? this.value.includes(this.checked) : this.value === this.checked;
}

function isMultiple(){
  return Array.isArray(this.value);
}